// JSX Runtime shim for React 16.8
// This provides compatibility for libraries that use the new JSX transform
// when running on React 16 which doesn't have react/jsx-runtime
const React = require('react');

function jsx(type, props, key) {
  const { children, ...restProps } = props || {};
  if (key !== undefined) {
    restProps.key = key;
  }
  if (children !== undefined) {
    if (Array.isArray(children)) {
      return React.createElement(type, restProps, ...children);
    }
    return React.createElement(type, restProps, children);
  }
  return React.createElement(type, restProps);
}

function jsxs(type, props, key) {
  return jsx(type, props, key);
}

module.exports = {
  jsx,
  jsxs,
  Fragment: React.Fragment,
};

